import { SearchRequestErrorType } from '@/entities/search'

export const defaultErrors = {
	[SearchRequestErrorType.DESTINATION]: null,
	[SearchRequestErrorType.CALENDAR]: null,
	[SearchRequestErrorType.GUESTS]: null
}
